module.exports = __webpack_public_path__ + "assets/a96b7884267e50f4ec06b4e138d4e571.png";